/* Free-gift guard
 *
 * Enforces the funnel free-gift rules client-side, no matter how the cart is
 * mutated (drawer steppers, /cart page, repeated ATC, direct cart URLs):
 *
 *   1. A gift line (product handle starts with "free-", unit price $0) may
 *      only exist while a QUALIFYING subscription line is in the cart.
 *      - Gifts added after this guard shipped carry a hidden line property
 *        `_free_gift_for` = product_id of the subscription product that
 *        earned them; the matching selling-plan line must still be present.
 *      - Legacy gift lines without the property just require ANY
 *        selling-plan line.
 *   2. Gift line quantity is clamped to 1.
 *
 * Runs on page load and after every cart drawer update/render/open event,
 * then re-renders the drawer (or reloads /cart) if it had to fix anything.
 * Loaded from layout/theme.liquid and layout/funnel.liquid.
 */
(function () {
  'use strict';

  var busy = false;
  var timer = null;

  function isGift(item) {
    var price = typeof item.final_price === 'number' ? item.final_price : item.price;
    return price === 0 && typeof item.handle === 'string' && item.handle.indexOf('free-') === 0;
  }

  function reconcile() {
    if (busy) { return; }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var subs = (cart.items || []).filter(function (i) { return !!i.selling_plan_allocation; });
        var fixes = [];
        (cart.items || []).forEach(function (item) {
          if (!isGift(item)) { return; }
          var trigger = item.properties && item.properties._free_gift_for;
          var qualified = trigger
            ? subs.some(function (s) { return String(s.product_id) === String(trigger); })
            : subs.length > 0;
          if (!qualified) {
            fixes.push({ id: item.key, quantity: 0 });
          } else if (item.quantity > 1) {
            fixes.push({ id: item.key, quantity: 1 });
          }
        });
        if (!fixes.length) { busy = false; return; }

        var chain = Promise.resolve();
        fixes.forEach(function (fix) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(fix)
            });
          });
        });
        return chain.then(function () {
          busy = false;
          if (location.pathname.indexOf('/cart') === 0) {
            location.reload();
            return;
          }
          if (window.eventBus && window.eventBus.emit) {
            window.eventBus.emit('render:cart:drawer');
          }
        });
      })
      .catch(function () { busy = false; });
  }

  function debounced() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', debounced);
  } else {
    debounced();
  }

  /* eventBus.js loads deferred too - poll briefly until it exists. */
  (function hook(attempt) {
    if (window.eventBus && window.eventBus.on) {
      window.eventBus.on('update:cart:drawer', debounced);
      window.eventBus.on('render:cart:drawer', debounced);
      window.eventBus.on('open:cart:drawer', debounced);
    } else if (attempt < 50) {
      setTimeout(function () { hook(attempt + 1); }, 200);
    }
  })(0);
})();
